export default {
    namespaced: true,

    state: {
        currency_balance_owing_in_cents: 0,
        transaction_date: '',
        entity_id: '',
        currency_id: '',
    },

    mutations: {
        setData(state, data) {
            state.currency_balance_owing_in_cents = data.currency_balance_owing_in_cents;
            state.transaction_date = data.transaction_date;
            state.entity_id = data.entity_id;
            state.currency_id = data.currency_id;
        },

        setMemoData(state, data) {
            state.received_credit = data.received_credit ?? null;
            state.notes = data.reason_for_voiding ?? data.reason_for_refunding;
            state.action = data.action;
        },

        reset(state) {
            state.currency_balance_owing_in_cents = 0;
            state.transaction_date = '';
            state.entity_id = '';
        },
    },
};
